import { helpbuttonStyle, convertToLocalStyle, getFluctuationPopupStyle, getFluctuationLoadingStyle } from '@bingads-webui-campaign-react/common-styles';

export const getTopChangeCardStyle = palette => ({
  '@global': {
    ...getFluctuationPopupStyle({ palette }),
    ...getFluctuationLoadingStyle(),
    '.bingads-fluctuation-wrapper .card-holder__wrapper': {
      minWidth: '20px !important',
      border: 'none !important',
      flexDirection: 'row !important',
      boxShadow: 'none !important',
      marginBottom: -4,

      '& .left.carousel-control': {
        left: '5px !important',
      },

      '& .right.carousel-control': {
        right: '0px !important',
        width: '35px !important',
      },
    },
  },
  '.top-changes-card': {
    paddingBottom: 16,
    display: 'flex',
    flexDirection: 'column',
    fontSize: 12,
    minHeight: 1,

    ...convertToLocalStyle(helpbuttonStyle({ palette })),
    '& .top-changes-card-header': {
      display: 'flex',
      margin: '15px 0 0px',
      alignItems: 'flex-start',
      '& .popComparisonRange': {
        flex: '1',
        marginRight: 15,
        color: palette.neutralSecondary,
      },
      '& .popComparisonRange .helpbutton': {
        marginLeft: 5,
      },
      '& .top-changes-card_metric': {
        flex: '0',
      },
      '& .metric-container': {
        marginRight: 20,
      },
    },
    '& .top-change-grid-container': {
      display: 'flex',
      flex: '1 1',
      justifyContent: 'center',
      overflowY: 'auto',
      overflowX: 'hidden',
      '& .top-change-empty': {
        alignSelf: 'center',
        fontSize: '14px',
      },
      '& .top-change-grid': {
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 33.33%) minmax(0, 16.67%) minmax(0, 16.67%) minmax(max-content, 1fr) minmax(max-content, max-content) minmax(max-content, max-content)',
        alignItems: 'stretch',
        flex: '1',
        alignSelf: 'flex-start',

        '& .top-change-grid-row-20': {
          gridRow: '20',
          borderTop: `1px solid ${palette.neutralLighter}`,
        },
        '& .top-change-grid-row-19': {
          gridRow: '19',
          borderTop: `1px solid ${palette.neutralLighter}`,
        },
        '& .top-change-grid-row-18': {
          gridRow: '18',
          borderTop: `1px solid ${palette.neutralLighter}`,
        },
        '& .top-change-grid-row-17': {
          gridRow: '17',
          borderTop: `1px solid ${palette.neutralLighter}`,
        },
        '& .top-change-grid-row-16': {
          gridRow: '16',
          borderTop: `1px solid ${palette.neutralLighter}`,
        },
        '& .top-change-grid-row-15': {
          gridRow: '15',
          borderTop: `1px solid ${palette.neutralLighter}`,
        },
        '& .top-change-grid-row-14': {
          gridRow: '14',
          borderTop: `1px solid ${palette.neutralLighter}`,
        },
        '& .top-change-grid-row-13': {
          gridRow: '13',
          borderTop: `1px solid ${palette.neutralLighter}`,
        },
        '& .top-change-grid-row-12': {
          gridRow: '12',
          borderTop: `1px solid ${palette.neutralLighter}`,
        },
        '& .top-change-grid-row-11': {
          gridRow: '11',
          borderTop: `1px solid ${palette.neutralLighter}`,
        },
        '& .top-change-grid-row-10': {
          gridRow: '10',
          borderTop: `1px solid ${palette.neutralLighter}`,
        },
        '& .top-change-grid-row-9': {
          gridRow: '9',
          borderTop: `1px solid ${palette.neutralLighter}`,
        },
        '& .top-change-grid-row-8': {
          gridRow: '8',
          borderTop: `1px solid ${palette.neutralLighter}`,
        },
        '& .top-change-grid-row-7': {
          gridRow: '7',
          borderTop: `1px solid ${palette.neutralLighter}`,
        },
        '& .top-change-grid-row-6': {
          gridRow: '6',
          borderTop: `1px solid ${palette.neutralLighter}`,
        },
        '& .top-change-grid-row-5': {
          gridRow: '5',
          borderTop: `1px solid ${palette.neutralLighter}`,
        },
        '& .top-change-grid-row-4': {
          gridRow: '4',
          borderTop: `1px solid ${palette.neutralLighter}`,
        },
        '& .top-change-grid-row-3': {
          gridRow: '3',
          borderTop: `1px solid ${palette.neutralLighter}`,
        },
        '& .top-change-grid-row-2': {
          gridRow: '2',
          borderTop: `1px solid ${palette.neutralLighter}`,
        },
        '& .top-change-grid-row-1': {
          gridRow: '1',
          borderTop: `1px solid ${palette.neutralLighter}`,
        },
        '& .top-change-entity-name': {
          gridColumn: '1',
          borderRight: '1px solid #EFEFEF',
          display: 'flex',
          alignItems: 'center',
          minHeight: 48,
          paddingLeft: 10,
          paddingRight: 10,
        },
        '& .top-change-entity-name .status': {
          marginRight: 5,
        },
        '& .top-change-entity-name a': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          minWidth: 1,
          whiteSpace: 'nowrap',
        },
        '& .top-change-graph-decline': {
          gridColumn: '2',
          borderRight: '1px solid #CBCBCB',
          padding: '5px 0 5px 5px',
          display: 'flex',
          alignItems: 'center',
          backgroundColor: palette.neutralLighter,
        },
        '& .top-change-graph-decline .decline-box': {
          display: 'flex',
          height: 30,
          width: '100%',
        },
        '& .top-change-graph-decline .decline-box .graph-bar': {
          backgroundColor: palette.themePrimary,
        },
        '& .top-change-graph-increase': {
          gridColumn: '3',
          borderRight: '1px solid #EFEFEF',
          padding: '5px 5px 5px 0',
          display: 'flex',
          alignItems: 'center',
          backgroundColor: palette.neutralLighter,
        },
        '& .top-change-graph-increase .increase-box': {
          display: 'flex',
          height: 30,
          width: '100%',
        },
        '& .top-change-graph-increase .increase-box .graph-bar': {
          backgroundColor: '#01188F',
        },
        '& .insight-hover-target .hover-content': {
          top: '0 !important',
          width: 140,
          right: 'auto !important',
        },
        '& .mcc-perf-fluctuation-bulb-container:hover .hover-container': {
          display: 'block',
          position: 'relative',
          left: 'calc(-50% - 30px)',
        },
        '& .mcc-perf-fluctuation-bulb-container': {
          gridColumn: '4',

          '& .mcc-perf-fluctuation-bulb': {
            padding: 10,
            width: 30,
            cursor: 'pointer',
          },

          '& .mcc-perf-fluctuation-bulb:before': {
            fontFamily: 'MsAds MDL2 Assets',
            color: '#0078D4',
            fontSize: 16,
          },
        },
        '& .pop-change': {
          gridColumn: '5',
          fontSize: 15,
          color: palette.neutralPrimary,
          paddingLeft: 10,
          paddingTop: 12,
          textAlign: 'right',
        },
        '& .pop-change-percentage': {
          gridColumn: '6',
          fontSize: 12,
          color: palette.neutralSecondary,
          paddingLeft: 15,
          paddingTop: 15,
          textAlign: 'right',
        },
        '& .pop-range': {
          gridColumn: '7',
          fontSize: 12,
          color: palette.neutralSecondary,
          paddingLeft: 15,
          paddingRight: 26,
          paddingTop: 15,
          textAlign: 'right',
        },
        '& .graph-hover-target': {
          gridColumn: '2 / span 2',
          background: 'none',
          zIndex: '1',
          border: 'none !important',
        },
        '& .pop-hover-target': {
          gridColumn: '5 / span 2',
          background: 'none',
          zIndex: '1',
          border: 'none !important',
        },
        '& .graph-hover-target:hover .hover-container': {
          display: 'block',
        },
        '& .pop-hover-target:hover .hover-container': {
          display: 'block',
        },
        '& .kpi-increased .bar-icon': {
          display: 'inline-block',
          backgroundColor: '#01188F',
        },
        '& .kpi-declined .bar-icon': {
          display: 'inline-block',
          backgroundColor: '#0078D7',
        },
        '& .bar-icon': {
          display: 'none',
          width: 12,
          height: 12,
          marginRight: 3,
        },
        '& .pop-hover-target .hover-container .hover-content': {
          right: '-150px',
        },
        '& .graph-hover-target .hover-container .hover-content': {
          left: '-150px',
        },
        '& .hover-container': {
          position: 'absolute',
          display: 'none',
          fontSize: 12,
          color: '#333333',
          width: '0',
          height: '0',
          marginLeft: 5,

          '& .hover-content': {
            position: 'absolute',
            zIndex: '10',
            padding: 15,
            bottom: '0',
            borderRadius: 2,
            boxShadow: '0 3.2px 7.2px 0 rgba(0,0,0,.132), 0 0.6px 1.8px 0 rgba(0,0,0,.108)',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            '@supports (backdrop-filter: blur(60px))': {
              backdropFilter: 'blur(60px)',
              backgroundColor: 'rgba(255, 255, 255, 0.25)',
            },
          },
          '& .hover-content:hover': {
            display: 'none',
          },
          '& .hover-content .entity-name': {
            wordBreak: 'break-all',
            paddingBottom: 10,
          },
          '& .hover-content .kpi-grid': {
            display: 'grid',
            gridTemplateColumns: 'minmax(max-content, max-content) minmax(max-content, max-content)',
          },
          '& .hover-content .kpi-grid .kpi-date-range': {
            paddingBottom: 10,
          },
          '& .hover-content .kpi-grid .kpi-data': {
            fontWeight: 'bold',
          },
          '& .hover-content .kpi-grid .kpi-current': {
            maxWidth: '240px',
            gridRow: '1',
            gridColumn: '1',
            borderRight: '1px solid #DDDDDD',
            paddingRight: 15,
          },
          '& .hover-content .kpi-grid .kpi-comparison': {
            maxWidth: '240px',
            gridColumn: '2',
            paddingLeft: 15,
          },
          '& .hover-content .kpi-grid .kpi-change': {
            gridRow: '2',
            gridColumn: '1 / span 2',
            paddingTop: 10,
            display: 'flex',
            alignItems: 'center',
          },
        },
        '& .top-change-grid-row-1 .hover-container .hover-content, .top-change-grid-row-2 .hover-container .hover-content': {
          top: 48,
          bottom: 'auto',
        },
      },
      '& .scroll-bar-cover': {
        position: 'absolute',
        background: 'white',
      },
      '&:hover .scroll-bar-cover': {
        display: 'none',
      },
    },
    '& .entity-links': {
      marginTop: 10,
    },
    '& .entity-links .view-all-clickLink': {
      flex: '0 0 auto',
    },
    '& .metric-picker': {
      padding: '0',
      border: '0',
      fontWeight: '600',
      margin: '0',
      fontSize: 12,
      lineHeight: 'normal',
      fallbacks: [
        {
          fontWeight: 'normal',
        },
      ],
    },
  },
});
